// Pool of ~200 unique social proof popup entries
const firstNames = ["James","Sophie","Klaus","Haruto","Michael","Aisha","Olivia","Lucas","Jennifer","Nathan","Emma","Liam","Mia","Noah","Ava","Ethan","Isabella","Mason","Charlotte","Logan","Amelia","Lucas","Harper","Benjamin","Evelyn","Sebastian","Abigail","Henry","Emily","Alexander","Sofia","Daniel","Camila","Matthew","Aria","Joseph","Scarlett","Samuel","Victoria","David","Madison","Carter","Luna","Owen","Grace","Wyatt","Chloe","John","Zoe","Jack"];
const lastInitials = ["A.","B.","C.","D.","E.","F.","G.","H.","J.","K.","L.","M.","N.","O.","P.","R.","S.","T.","W.","Z."];

const locations = [
  ["🇺🇸","Texas"],["🇺🇸","New York"],["🇺🇸","California"],["🇺🇸","Miami"],["🇺🇸","Chicago"],
  ["🇬🇧","London"],["🇬🇧","Manchester"],["🇬🇧","Edinburgh"],
  ["🇩🇪","Berlin"],["🇩🇪","Munich"],["🇩🇪","Hamburg"],
  ["🇯🇵","Tokyo"],["🇯🇵","Osaka"],
  ["🇸🇬","Singapore"],
  ["🇦🇺","Sydney"],["🇦🇺","Melbourne"],
  ["🇫🇷","Paris"],["🇫🇷","Lyon"],
  ["🇨🇦","Toronto"],["🇨🇦","Vancouver"],
  ["🇳🇱","Amsterdam"],
  ["🇦🇪","Dubai"],["🇦🇪","Abu Dhabi"],
  ["🇨🇭","Zurich"],
  ["🇸🇪","Stockholm"],
  ["🇮🇹","Milan"],["🇮🇹","Rome"],
  ["🇪🇸","Madrid"],["🇪🇸","Barcelona"],
  ["🇰🇷","Seoul"],
  ["🇳🇿","Auckland"],
  ["🇮🇪","Dublin"],
  ["🇧🇪","Brussels"],
  ["🇳🇴","Oslo"],
];

const tiers = [
  ["Starter",1000],["Growth",5000],["Premium",8000],["Elite",10000],["Platinum VIP",25000]
];

const actions = [
  { type: "invest", tpl: (n, loc, tier, amount, time) => `${n} from ${loc} just funded a $${amount.toLocaleString()} ${tier} real investment - ${time}` },
  { type: "withdraw", tpl: (n, loc, _t, amount, time) => `${n} from ${loc} just withdrew $${amount.toLocaleString()} in profits - ${time}` },
  { type: "activate", tpl: (n, loc, tier, amount, time) => `${n} from ${loc} just activated the ${tier} AI Bot with $${amount.toLocaleString()} - ${time}` },
  { type: "join", tpl: (n, loc, tier, amount, time) => `${n} from ${loc} just subscribed to a $${amount.toLocaleString()} ${tier} AI Bot - ${time}` },
  { type: "reinvest", tpl: (n, loc, _t, amount, time) => `${n} from ${loc} just reinvested $${amount.toLocaleString()} - ${time}` },
  { type: "joint", tpl: (n, loc, _t, amount, time) => `${n} from ${loc} just activated a Joint Account with $${amount.toLocaleString()} - ${time}` },
];

const times = ["just now","1 minute ago","2 minutes ago","3 minutes ago","4 minutes ago","5 minutes ago","6 minutes ago","8 minutes ago","10 minutes ago","12 minutes ago"];

function rand(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

export function generatePool(n = 220) {
  const pool = [];
  const seen = new Set();
  while (pool.length < n) {
    const fn = rand(firstNames);
    const li = rand(lastInitials);
    const [flag, city] = rand(locations);
    const [tierName, baseAmt] = rand(tiers);
    const act = rand(actions);
    const amount = act.type === "withdraw" ? Math.round((baseAmt * (0.4 + Math.random() * 1.5)) / 10) * 10 : Math.round(baseAmt * (0.9 + Math.random() * 0.5));
    const time = rand(times);
    const text = act.tpl(`${fn} ${li}`, city, tierName, amount, time);
    const key = `${fn}${li}${city}${act.type}${amount}`;
    if (seen.has(key)) continue;
    seen.add(key);
    pool.push({ flag, text, type: act.type });
  }
  return pool;
}